import { Store } from 'redux';
import { createAction } from 'typesafe-actions';

export type NotificationSeverity = 'error' | 'info' | 'success' | 'warning';

const showNotificationAction = createAction('@notifications/SHOW_NOTIFICATION')<{
  intlId: string;
  severity?: NotificationSeverity;
  closeButtonIntlId?: string;
  message?: string;
  closeButtonText?: string;
}>();
export class NotificationService {
  constructor(private globalReduxStore: Store) {}

  public showNotification(
    intlId: string,
    severity?: NotificationSeverity,
    closeButtonIntlId?: string,
  ): void {
    this.globalReduxStore.dispatch(showNotificationAction({ intlId, severity, closeButtonIntlId }));
  }

  public showNotificationMessage(
    message: string,
    severity?: NotificationSeverity,
    closeButtonText?: string,
  ): void {
    this.globalReduxStore.dispatch(
      showNotificationAction({ intlId: '', severity, closeButtonText, message }),
    );
  }
}
